import { FACILITIES_LIST } from 'features/generator/contentFormSections/FacilitiesForm/facilitiesConfig'
import { facilitiesAtom } from 'features/generator/contentFormSections/FacilitiesForm/FacilitiesForm'
import { FacilityButton } from 'features/generator/contentFormSections/FacilitiesForm/FacilityButton'
import { useAtomValue } from 'jotai'

export const FacilitySection = () => {
	const selectedFacilities = useAtomValue(facilitiesAtom)

	return (
		<ul className="flex flex-wrap gap-2">
			{FACILITIES_LIST()
				.filter(({ id }) => selectedFacilities.includes(id))
				.map(({ id, name, icon: Icon }) => (
					<li key={id}>
						<FacilityButton name={name} Icon={Icon} previewMode />
					</li>
				))}
		</ul>
	)
}
